import apiClient from "api-client";

import getWrappedUseMutation from "../../helpers/getWrappedUseMutation";

export const useCreateSelectionOptionMutation = getWrappedUseMutation(apiClient.ForumAttendees.selectionChoice.post);

export const useUpdateSelectionOptionMutation = getWrappedUseMutation(apiClient.ForumAttendees.selectionChoice.put);

export const useDeleteSelectionOptionMutation = getWrappedUseMutation(apiClient.ForumAttendees.selectionChoice.delete);
